import { authHeader } from '../helpers';
import { defineConfig } from '../config'
import { utilsService } from './utils'
const {handleResponse} = utilsService

export const shareService = {
  getApiPath,
  createShare,
  getSharesByResource,
  updateShare,
  deleteShare,
  sendShareLink,
};

const { apiUrl, apiVer } = defineConfig.SHARE_SERVICE

function getApiPath() {
  return (apiUrl + apiVer + "/share")
}

function createShare(shareObj) {
  const url = getApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(shareObj)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteShare(id) {
  const url = getApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSharesByResource(resourceId, resourceType) {
  const url = getApiPath() + "/all/" + resourceType + "/" + resourceId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateShare(id, shareObj) {
  const url = getApiPath() + "/update/" + id;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(shareObj)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function sendShareLink(id) {
  const url = getApiPath() + "/send/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}